import React from "react";

import "./recupelIncluded.scss";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

const RecupelIncluded = () => {
    const { t } = useGranite();

    return (
        <div className="recupel-included">
            <p>{t('ecommerce.label.recupel-included')}</p>
        </div>
    );
};

export default RecupelIncluded;
